// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `offline-switch .offline-div.available {
  display: inline-block;
  width: 200px;
  margin-top: 0px;
  height: 20px;
}
offline-switch .offline-switch {
  margin-left: 0px;
}
offline-switch .offline-div {
  text-align: center;
  width: 200px;
  margin: auto;
  margin-top: 20px;
}
offline-switch .offline-label {
  font-size: 0.9em;
}
offline-switch .offline-size {
  padding: 6px;
}
offline-switch .switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin: auto;
  margin-top: 6px;
}
offline-switch .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
offline-switch .check-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #999999;
  transition: 0.4s;
  border-radius: 34px;
}
offline-switch .check-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
offline-switch input:checked + .check-slider.ongoing {
  background-color: var(--motes-gold);
}
offline-switch input:checked + .check-slider.cached {
  background-color: var(--motes-green);
}
offline-switch input:checked + .check-slider:before {
  transform: translateX(26px);
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/offline/offline-components/offline-switch.component.scss"],"names":[],"mappings":"AACI;EACI,qBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAAR;AAGI;EACI,gBAAA;AADR;AAII;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,YAAA;AAJR;AAQI;EACI,kBAAA;EACA,qBAAA;EACA,WAJW;EAKX,YAAA;EACA,YAAA;EACA,eAAA;AANR;AASI;EACI,UAAA;EACA,QAAA;EACA,SAAA;AAPR;AAUI;EACI,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EAEA,gBAAA;EACA,mBAAA;AARR;AAWI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;EACA,kBAAA;AATR;AAYI;EACI,mCAAA;AAVR;AAcI;EACI,oCAAA;AAZR;AAmBI;EAGI,2BAAA;AAjBR","sourcesContent":["offline-switch {\n    .offline-div.available {\n        display: inline-block;\n        width: 200px;\n        margin-top: 0px;\n        height: 20px;\n    }\n\n    .offline-switch {\n        margin-left: 0px;\n    }\n\n    .offline-div {\n        text-align: center;\n        width: 200px;\n        margin: auto;\n        margin-top: 20px;\n    }\n\n    .offline-label {\n        font-size: 0.9em;\n    }\n\n    .offline-size {\n        padding: 6px;\n    }\n\n    $switch-width: 60px;\n    .switch {\n        position: relative;\n        display: inline-block;\n        width: $switch-width;\n        height: 34px;\n        margin: auto;\n        margin-top: 6px;\n    }\n\n    .switch input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .check-slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: #999999;\n        -webkit-transition: .4s;\n        transition: .4s;\n        border-radius: 34px;\n    }\n\n    .check-slider:before {\n        position: absolute;\n        content: \"\";\n        height: 26px;\n        width: 26px;\n        left: 4px;\n        bottom: 4px;\n        background-color: white;\n        -webkit-transition: .4s;\n        transition: .4s;\n        border-radius: 50%;\n    }\n\n    input:checked + .check-slider.ongoing {\n        background-color: var(--motes-gold);\n        // background-color: var(--motes-orange);\n    }\n\n    input:checked + .check-slider.cached {\n        background-color: var(--motes-green);\n    }\n\n    input:focus + .check-slider {\n        // background-color: var(--motes-orange);\n    }\n\n    input:checked + .check-slider:before {\n        -webkit-transform: translateX($switch-width - 34px);\n        -ms-transform: translateX($switch-width - 34px);\n        transform: translateX($switch-width - 34px);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
